import { render, staticRenderFns } from "./PolicyPrivacy.vue?vue&type=template&id=6342730a"
var script = {}
import style0 from "./PolicyPrivacy.vue?vue&type=style&index=0&id=6342730a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports